export const fastTransition = `transition: all 0.1s ease-in-out`;
export const medTransition = `transition: all 0.3s ease-in-out;`;
